const pdfFfiles = {
    file2 : {
        name: "Predugovorno obavještenje",
        link: "https://prodaja.lo.co.me/putno/PredugovornoObavjestenje.pdf",
    },
    file3 : {
        name: "Saglasnost za direktni marketing",
        link: "https://prodaja.lo.co.me/uslovi/Saglasnost%20za%20direktni%20marketing.pdf",
    },
    file4 : {
        name: "Obavještenje o obradi podataka",
        link: "https://prodaja.lo.co.me/uslovi/Obavje%C5%A1tenje%20o%20obradi%20podataka.pdf",
    },
    file5 : {
        name: "Opšti uslovi za osiguranje lica od posledica nesrećnog slučaja (nezgode)",
        link: "https://prodaja.lo.co.me/uslovi/US-NE-14-03-cg 2019.pdf",
    },
    file6 : {
        osnovna : {
            name : "Dopunski uslovi za osiguranje djece od posledica nesrednog slučaja do završetka osnovnog školovanja" ,
            link : "https://prodaja.lo.co.me/uslovi/US-nuc-OTR-18-04-cg 2019.pdf" ,
        },
        srednja : {
            name : "Dopunski uslovi za osiguranje učenika srednjih škola i studenata od posledica nesrednog slučaja" ,
            link : "https://prodaja.lo.co.me/uslovi/US-nuc-DIS-18-04-cg 2019.pdf" ,
        }
    }
};

export default pdfFfiles;